export const PRODUCTS = [
  {
    id: 'ix6g',
    name: 'Original',
    price: 1.4,
    description: '250 mL',
    longDesc:
      'O Kombuchai Tea é uma bebida de chá fermentada pasteurizada que é probiótica, energizante e refrescante. As folhas naturais da planta Camellia sinensis de chá verde conferem a este refrigerante fermentado e levemente efervescente um sabor único.',
    img: require('../../assets/Original_250.jpg'),
  },
  {
    id: 'nkcq',
    name: 'Frutos Silvestre',
    price: 1.4,
    description: '250 mL',
    longDesc:
      'Bebida de chá verde naturalmente fermentada com sabor a amoras, framboesas e mirtilos, derivados de uma produção biológica nacional, que confere a este refrigerante fermentado e levemente efervescente o seu sabor especial.',
    img: require('../../assets/FrutosSilvestres_250.jpg'),
  },
  {
    id: 'jdmu',
    name: 'Gengibre + Limão',
    price: 1.4,
    description: '250 mL',
    longDesc:
      'Bebida de chá verde naturalmente fermentada com sabor a gengibre e limão. A combinação harmoniosa de gengibre e limão dá a este refrigerante fermentado e ligeiramente efervescente um sabor incomparável.',
    img: require('../../assets/GengibreLimao_250.jpg'),
  },
  {
    id: 'ih9z',
    name: 'Hibisco',
    price: 1.4,
    description: '250 mL',
    longDesc:
      'Bebida de chá verde naturalmente fermentada com sabor a hibisco. Produzido seguindo técnica milenar, o nosso kombucha de hibisco nasce da fermentação do chá verde com infusão de sépalas da flor Hibiscus sabdariffa, que confere a este refrigerante fermentado e levemente efervescente uma bebida cheia de sabor.',
    img: require('../../assets/Hibisco_250.jpg'),
  },
  {
    id: '3f68',
    name: 'Frutos Silvestres',
    price: 2.8,
    description: '750 mL',
    longDesc:
      'Bebida de chá verde naturalmente fermentada com sabor a amoras, framboesas e mirtilos, derivados de uma produção biológica nacional, que confere a este refrigerante fermentado e levemente efervescente o seu sabor especial.',
    img: require('../../assets/FrutosSilvestres_750.jpg'),
  },
  {
    id: 'qigc',
    name: 'Gengibre + Limão',
    price: 2.8,
    description: '750 mL',
    longDesc:
      'Bebida de chá verde naturalmente fermentada com sabor a gengibre e limão. A combinação harmoniosa de gengibre e limão dá a este refrigerante fermentado e ligeiramente efervescente um sabor incomparável.',
    img: require('../../assets/GengibreLimao_750.jpg'),
  },
  {
    id: 'pn2i',
    name: 'Hibisco',
    price: 2.8,
    description: '750 mL',
    longDesc:
      'Bebida de chá verde naturalmente fermentada com sabor a hibisco. Produzido seguindo técnica milenar, o nosso kombucha de hibisco nasce da fermentação do chá verde com infusão de sépalas da flor Hibiscus sabdariffa, que confere a este refrigerante fermentado e levemente efervescente uma bebida cheia de sabor.',
    img: require('../../assets/Hibisco_750.jpg'),
  },
  {
    id: 'z308',
    name: 'Original',
    price: 2.8,
    description: '750 mL',
    longDesc:
      'O Kombuchai Tea é uma bebida de chá fermentada pasteurizada que é probiótica, energizante e refrescante. As folhas naturais da planta Camellia sinensis de chá verde conferem a este refrigerante fermentado e levemente efervescente um sabor único.',
    img: require('../../assets/Original_750.jpg'),
  },
  {
    id: 'ksal',
    name: 'Pack Experiência',
    price: 4.99,
    description: '4 x 250 mL',
    longDesc:
      'O pack experiência é a nossa explosão de energia e sabor! Com 4 variedades de sabores, para uma experiência única e inesquecível deste refrigerante',
    img: require('../../assets/Pack4.jpg'),
  },
  {
    id: '19pj',
    name: 'Kit Do It Yourself',
    price: 25,
    description: '1 unidade',
    longDesc:
      'Este kit tem tudo o que você precisa para começar a preparar seu próprio kombucha em casa. O kit contém:  1 frasco fermentador de 3L, um SCOBY biológico e um pouco de starter (atuando como um inóculo), um chá verde também biológico, 100 g de açúcar de produção biológica e um termómetro para colar ao frasco para controlo da temperatura.',
    img: require('../../assets/packDIY.jpg'),
  },
];

export default PRODUCTS;
